export default "/images/pin_map_google_icon.svg?2772f02fee1da735711b37576d6a1226";